/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { PAGE_NAMES } from '@zcode/mixpanel'
import type { StaticContext } from 'react-router'
import type { RouteComponentProps } from 'react-router-dom'

import {
  checkDetailView,
  checkHomepageView,
  checkPermanentAddressView,
  selectIsRailPage,
} from '../../../inspectors'
import { logger } from '../../../logger'
import type { RouteProps } from '../../types'

// TODO: There is similar logic at nzr/src/utils/getPageType.js that we use on the server and at
// nzr/src/server/utils/determinePageType.ts that we use for the server. Each serves a slightly
// different purpose currently but we should eventually consolidate. This version uses a different set of constants
// for page names that don't match up 1-to-1 with how we log them in the other two files for grafana for server metrics and client web-vitals
export const getPageNameFromRouteProps = ({
  routeProps,
  isMobile,
}: {
  routeProps: RouteProps
  isMobile: boolean
}) => {
  if (routeProps?.location) {
    let page
    if (selectIsRailPage(routeProps as RouteComponentProps<{}, StaticContext, any>)) {
      page = isMobile ? PAGE_NAMES.SEARCH_LIST : PAGE_NAMES.SEARCH
    } else if (checkHomepageView(routeProps)) {
      page = PAGE_NAMES.HOMEPAGE
    } else if (checkDetailView(routeProps as RouteComponentProps<{}, StaticContext, any>)) {
      page = PAGE_NAMES.DETAIL
    } else if (checkPermanentAddressView(routeProps)) {
      page = PAGE_NAMES.PERM_ADDRESS
    } else {
      const { location } = routeProps
      page = location?.pathname && location.search && `${location.pathname}${location.search}`
    }
    return page
  } else {
    logger.error('getPageNameFromRouteProps called without routeProps:', routeProps)
  }
}
